import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import bookmarkImage from './bookmark.svg';
import calendarImage from './calendar.svg';
import searchImage from './search.svg';
import heartImage from './heart.svg';
import notificationImage from './notification.svg';
import cartImage from './cart.svg';
import boxImage from './box.svg';

function EmptyState({ type, message, className }) {
  const images = {
    bookmark: bookmarkImage,
    calendar: calendarImage,
    search: searchImage,
    heart: heartImage,
    notification: notificationImage,
    cart: cartImage,
    box: boxImage
  };

  return (
    <div className={classNames('blendx-empty-state', className)}>
      <img
        className="blendx-empty-state__image"
        src={images[type]}
        alt={message}
      />
      <p className="blendx-empty-state__message">{message}</p>
    </div>
  );
}

EmptyState.propTypes = {
  type: PropTypes.oneOf(['bookmark', 'box', 'calendar', 'search', 'heart', 'notification', 'cart']),
  message: PropTypes.string,
  className: PropTypes.string
};

EmptyState.defaultProps = {
  type: 'box',
  message: 'No results found',
  className: ''
};

export default EmptyState;
